import NotFound from "../core/NotFound/NotFound";
import { SentryRoute } from "../core/SentryRoute";
import { Switch, useRouteMatch } from 'react-router-dom';
import { ContractDetails } from "./details/ContractDetails";
import { ContractsListPage } from "./list/ContractsListPage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContractsPage = () => {
  const match = useRouteMatch();
  return /*#__PURE__*/_jsxs(Switch, {
    "data-sentry-element": "Switch",
    "data-sentry-component": "ContractsPage",
    "data-sentry-source-file": "ContractsPage.tsx",
    children: [/*#__PURE__*/_jsx(SentryRoute, {
      exact: true,
      path: match.path,
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "ContractsPage.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(ContractsListPage, {
        "data-sentry-element": "ContractsListPage",
        "data-sentry-source-file": "ContractsPage.tsx",
        "data-sentry-element": "ContractsListPage"
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      path: `${match.path}/:contractId`,
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "ContractsPage.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(ContractDetails, {
        "data-sentry-element": "ContractDetails",
        "data-sentry-source-file": "ContractsPage.tsx",
        "data-sentry-element": "ContractDetails"
      })
    }), /*#__PURE__*/_jsx(SentryRoute, {
      "data-sentry-element": "SentryRoute",
      "data-sentry-source-file": "ContractsPage.tsx",
      "data-sentry-element": "SentryRoute",
      children: /*#__PURE__*/_jsx(NotFound, {
        "data-sentry-element": "NotFound",
        "data-sentry-source-file": "ContractsPage.tsx",
        "data-sentry-element": "NotFound"
      })
    })]
  });
};